import { useQuery } from "@tanstack/react-query";
import customersService from "services/admin/customersService";

export const useGetCustomers = (queryParams = {}) => {
    return useQuery({
        queryKey: ['customers', queryParams],
        queryFn: async () => {
            return customersService.getAll(queryParams)
        }
    })
}